// extracted by mini-css-extract-plugin
var _1 = "EditBuildingAndCategoryModalFormBody-moduleactions__LnqTM FormActions-moduleFormActions__WNNEs";
export { _1 as "actions" }
